import { useState } from 'react'
import { X, Coins, Check } from 'lucide-react'
import { useToast } from '../lib/ToastContext'

const PRICING = [
  { id: 'single', label: '1 Token', price: 15000, note: 'Single compliance agent request' },
  { id: 'bundle', label: '5 Tokens', price: 60000, note: 'Save 20% — best value', highlight: true },
]

export default function ServiceTokenModal({ open, onClose, onPurchase, currency = 'NGN' }) {
  const [selected, setSelected] = useState('bundle')
  const [processing, setProcessing] = useState(false)
  const { toast } = useToast()

  if (!open) return null

  const handlePurchase = () => {
    setProcessing(true)
    setTimeout(() => {
      setProcessing(false)
      const plan = PRICING.find((p) => p.id === selected)
      const tokens = selected === 'single' ? 1 : 5
      onPurchase?.(tokens)
      toast(`Purchase successful: ${tokens} agent service token${tokens > 1 ? 's' : ''} added to wallet.`, 'success')
      onClose?.()
    }, 1500)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-ink/40" onClick={onClose} aria-hidden />
      <div className="relative bg-surface border border-neutral-200 w-full max-w-md animate-fade-in">
        <div className="flex items-center justify-between px-6 py-4 border-b border-neutral-200">
          <div className="flex items-center gap-2">
            <Coins size={16} className="text-brand" />
            <h2 className="text-sm font-semibold text-ink">Agent Service Tokens</h2>
          </div>
          <button onClick={onClose} className="text-neutral-400 hover:text-ink"><X size={18} /></button>
        </div>

        <div className="px-6 py-5 space-y-5">
          <p className="text-xs text-muted leading-relaxed">
            Service tokens unlock localized legal assistance from our network of verified compliance agents. Each token covers one document request — from drafting to filing.
          </p>

          <div className="space-y-3">
            {PRICING.map((p) => (
              <button
                key={p.id}
                onClick={() => setSelected(p.id)}
                className={`w-full flex items-center justify-between px-4 py-3 border text-left transition-colors ${
                  selected === p.id
                    ? 'border-brand bg-brand-soft'
                    : 'border-neutral-200 hover:border-neutral-300'
                }`}
              >
                <div className="flex items-center gap-3">
                  <div className={`w-4 h-4 border-2 flex items-center justify-center ${selected === p.id ? 'border-brand bg-brand' : 'border-neutral-300'}`}>
                    {selected === p.id && <Check size={10} className="text-white" />}
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-ink">{p.label}</p>
                    <p className="text-[11px] text-muted">{p.note}</p>
                  </div>
                </div>
                <span className="font-mono text-sm text-ink">{currency === 'NGN' ? '\u20A6' : '$'}{(p.price / 1000).toFixed(0)}k</span>
              </button>
            ))}
          </div>

          <div className="flex gap-3 pt-1">
            <button onClick={onClose} className="btn-secondary">Cancel</button>
            <button
              onClick={handlePurchase}
              disabled={processing}
              className="btn-primary flex items-center gap-1.5"
            >
              {processing ? 'Processing...' : 'Purchase Token'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
